import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
import { CustomFieldTypeName } from "@air/api/types";
import { Skeleton } from "@air/component-skeleton";
import { memo } from "react";
export const CustomFieldsPanelContent = /*#__PURE__*/ memo((param)=>{
    let { fields, SelectCustomField, PlainTextCustomField, DateCustomField } = param;
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: !!fields ? fields.map((field)=>{
            switch(field.type.title){
                case CustomFieldTypeName.singleSelect:
                case CustomFieldTypeName.multiSelect:
                    {
                        return /*#__PURE__*/ _jsx(SelectCustomField, {
                            field: field
                        }, field.id);
                    }
                case CustomFieldTypeName.plainText:
                    {
                        return /*#__PURE__*/ _jsx(PlainTextCustomField, {
                            field: field
                        }, field.id);
                    }
                case CustomFieldTypeName.date:
                    return /*#__PURE__*/ _jsx(DateCustomField, {
                        field: field
                    }, field.id);
            }
        }) : /*#__PURE__*/ _jsx(Skeleton, {
            height: 20,
            width: 200
        })
    });
});
CustomFieldsPanelContent.displayName = "CustomFieldsPanelContent";
